import createIcon from '../../createIcon';

/**
 * @component @name AttachEmail
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjEgMTBWNEMyMSAyLjkgMjAuMSAyIDE5IDJIM0MxLjkgMiAxLjAxIDIuOSAxLjAxIDRMMSAxNkMxIDE3LjEgMS45IDE4IDMgMThIMTRWMTNDMTQgMTEuMzQgMTUuMzQgMTAgMTcgMTBIMjFaTTExIDExTDMgNlY0TDExIDlMMTkgNFY2TDExIDExWiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTIxIDE0VjE4QzIxIDE5LjEgMjAuMSAyMCAxOSAyMEMxNy45IDIwIDE3IDE5LjEgMTcgMThWMTMuNUMxNyAxMy4yMiAxNy4yMiAxMyAxNy41IDEzQzE3Ljc4IDEzIDE4IDEzLjIyIDE4IDEzLjVWMThIMjBWMTMuNUMyMCAxMi4xMiAxOC44OCAxMSAxNy41IDExQzE2LjEyIDExIDE1IDEyLjEyIDE1IDEzLjVWMThDMTUgMjAuMjEgMTYuNzkgMjIgMTkgMjJDMjEuMjEgMjIgMjMgMjAuMjEgMjMgMThWMTRIMjFaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const AttachEmail = createIcon('AttachEmail', [
  [
    'path',
    {
      d: 'M21 10V4C21 2.9 20.1 2 19 2H3C1.9 2 1.01 2.9 1.01 4L1 16C1 17.1 1.9 18 3 18H14V13C14 11.34 15.34 10 17 10H21ZM11 11L3 6V4L11 9L19 4V6L11 11Z',
      key: '1aigeg',
    },
  ],
  [
    'path',
    {
      d: 'M21 14V18C21 19.1 20.1 20 19 20C17.9 20 17 19.1 17 18V13.5C17 13.22 17.22 13 17.5 13C17.78 13 18 13.22 18 13.5V18H20V13.5C20 12.12 18.88 11 17.5 11C16.12 11 15 12.12 15 13.5V18C15 20.21 16.79 22 19 22C21.21 22 23 20.21 23 18V14H21Z',
      key: 'p6vlcs',
    },
  ],
]);

export default AttachEmail;
